export function TypingIndicator() {
  return (
    <div class="flex justify-start">
      <div class="flex items-center gap-1 rounded-2xl bg-white px-4 py-3 shadow-sm dark:bg-slate-800">
        <span class="typing-dot inline-block h-1.5 w-1.5 rounded-full bg-slate-400" />
        <span class="typing-dot inline-block h-1.5 w-1.5 rounded-full bg-slate-400" />
        <span class="typing-dot inline-block h-1.5 w-1.5 rounded-full bg-slate-400" />
      </div>
    </div>
  );
}
